import { UrlHelper, UrlHelperConfiguration } from './url-helper';
import { SensorStatusPieChart, AlertHistoryLineChart } from './charting';

interface OverviewDashboardConfiguration {
    ids: OverviewDashboardPageElementIds;
    statistics: OverviewDashboardStatistics;
    urlHelperConfiguration: UrlHelperConfiguration;
}

interface OverviewDashboardPageElementIds {
    refreshButton: string;
    sensorStatusPieChart: string;
    alertHistoryLineChart: string;
}

interface OverviewDashboardStatistics {
    totalSensors: number;
    offlineSensors: number;
    alertingSensors: number;
    alertsToday: number;
    alerts7days: number;
    alerts30days: number;
    alertHistogram: AlertHistogramEntry[];
}

interface AlertHistogramEntry {
    x: string;
    y: number;
}

$(document).on("turbolinks:load", function() {
    const configElement = document.getElementById("overview-dashboard-config");
    if (configElement) {
        const config: OverviewDashboardConfiguration = JSON.parse(configElement.innerHTML);
        const page = new OverviewDashboardPage(config.ids, config.statistics, new UrlHelper(config.urlHelperConfiguration));
        $(document).one("turbolinks:before-render", () => page.destroy());
    }
});

declare var Turbolinks: any;

export class OverviewDashboardPage {
    private sensorStatusPieChart: SensorStatusPieChart | null = null;
    private alertHistoryLineChart: AlertHistoryLineChart | null = null;

    constructor(private elementIds: OverviewDashboardPageElementIds, private statistics: OverviewDashboardStatistics, private urlHelper: UrlHelper) {
        $(`#${elementIds.refreshButton}`).on("click", () => {
            Turbolinks.clearCache();
            Turbolinks.visit(window.location);
        });
        this.sensorStatusPieChart = new SensorStatusPieChart(
            this.statistics.totalSensors,
            this.statistics.offlineSensors,
            this.statistics.alertingSensors,
            this.elementIds.sensorStatusPieChart,
            undefined,
            this.urlHelper);
        this.sensorStatusPieChart.render();

        this.alertHistoryLineChart = new AlertHistoryLineChart(this.statistics.alertHistogram, this.elementIds.alertHistoryLineChart);
        this.alertHistoryLineChart.render();
    }

    public destroy() {
        this.sensorStatusPieChart && this.sensorStatusPieChart.destroy();
        this.sensorStatusPieChart = null;
        this.alertHistoryLineChart && this.alertHistoryLineChart.destroy();
        this.alertHistoryLineChart = null;
    }
}